import BannerComponent from "./BannerComponent";
import CategoryComponent from "./CategoryComponent";
import EventComponent from "./EventComponent";
import FeaturedComponent from "./FeaturedComponent";
import GalleryComponent from "./GalleryComponent";
import InstructorComponent from "./InstructorComponent";
import NoticeComponent from "./NoticeComponent";
import RankingComponent from "./RankingComponent";
import ReviewComponent from "./ReviewComponent";
import ShortcutComponent from "./ShortcutComponent";
import TourComponent from "./TourComponent";
import VideoComponent from "./VideoComponent";
import CommunityComponent from "./CommunityComponent";

export const CMS_COMPONENT_MAP = {
  banner: BannerComponent,
  featured: FeaturedComponent,
  category: CategoryComponent,
  shortcut: ShortcutComponent,
  card: EventComponent,
  review: ReviewComponent,
  notice: NoticeComponent,
  video: VideoComponent,
  ranking: RankingComponent,
  instructor: InstructorComponent,
  tour: TourComponent,
  gallery: GalleryComponent,
  community:CommunityComponent
};

export {
  BannerComponent,
  FeaturedComponent,
  CategoryComponent,
  ShortcutComponent,
  EventComponent,
  ReviewComponent,
  NoticeComponent,
  VideoComponent,
  RankingComponent,
  InstructorComponent,
  TourComponent,
  GalleryComponent,
  CommunityComponent
};
